module.exports = __webpack_public_path__ + "img/faroe-islands.9fc932c9.png";